import { Outlet, createRootRoute } from '@tanstack/react-router';
import { ChatProvider } from '@/lib/chat-provider';
import { CallOverlay } from '@/components/chat/CallOverlay';

export const rootRoute = createRootRoute({
  component: RootLayout,
});

// The chat stream lives above every route so it survives navigation; the
// provider stays idle until a session is fully signed in.
function RootLayout(): JSX.Element {
  return (
    <ChatProvider>
      <Outlet />
      <CallOverlay />
    </ChatProvider>
  );
}
